__turbopack_context__.v({
  "answer": "Faq-module__jp4qaG__answer",
  "answerContent": "Faq-module__jp4qaG__answerContent",
  "answerInner": "Faq-module__jp4qaG__answerInner",
  "column": "Faq-module__jp4qaG__column",
  "doodle": "Faq-module__jp4qaG__doodle",
  "grid": "Faq-module__jp4qaG__grid",
  "head": "Faq-module__jp4qaG__head",
  "icon": "Faq-module__jp4qaG__icon",
  "intro": "Faq-module__jp4qaG__intro",
  "item": "Faq-module__jp4qaG__item",
  "itemTitle": "Faq-module__jp4qaG__itemTitle",
  "question": "Faq-module__jp4qaG__question",
  "questionText": "Faq-module__jp4qaG__questionText",
  "section": "Faq-module__jp4qaG__section",
  "title": "Faq-module__jp4qaG__title",
});
